import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import { setLayout } from "../reducers/layout";
import axiosWrapper from "../services/axiosWrapper";
import type { GetLayoutDataResponse } from "@ServerTypes/portal/portal.schema";

export function fetchLayout() {
  return async (dispatch: AppDispatch) => {
    const response = await axiosWrapper.get<GetLayoutDataResponse>(`${getBackendUrl()}/portal/getLayoutData`);
    if (response.data.status) {
      dispatch(setLayout(response.data.result));
    }
  };
}
